"use client";

import { useEffect } from "react";
import { useSession, signOut } from "next-auth/react";
import { useLocale } from "next-intl";

// If a logged-in user gets blocked by an admin, sign them out and send them to
// the login page with the "suspended" notice. session.user.blocked is refreshed
// from the DB by the jwt callback (throttled, so this can lag up to ~a minute).
// The block is enforced fresh server-side at login and booking regardless.
export function BlockGate() {
  const { data: session, status } = useSession();
  const locale = useLocale();

  useEffect(() => {
    if (status === "authenticated" && session?.user?.blocked) {
      signOut({ callbackUrl: `/${locale}/login?error=AccessDenied` });
    }
  }, [status, session, locale]);

  return null;
}
